<template>
  <div>
    <SupplyAndDemandHall v-if="false"></SupplyAndDemandHall>
    <div class="supply-hall" v-if="true">
      <!-- banner -->
      <div class="banner">
        <el-carousel class="carousel" trigger="click" :height="height" :indicator-position="swiperList.length>1 ?'intside':'none'" :arrow="swiperList.length>1 ?'hover':'never'">
          <el-carousel-item v-for="(item, index) in swiperList" :key="index">
            <div
              class="banner-img"
              :style="{ backgroundImage: 'url(' + item.picture_sit + ')' }"
              @click="handleSwiper(item)"
            ></div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 列表 -->
      <!-- 业务需求 -->
      <div class="list">
        <div class="listTitle">覆盖多种类的业务需求</div>
        <div class="buttonBox">
          <!-- <el-button type="primary" @click="handleRelease">发布需求</el-button> -->
          <el-button type="primary" @click="handleDemandList">更多</el-button>
        </div>
        <h1 v-if="list.length === 0">暂无数据</h1>
        <ul class="clearfix" v-if="list.length > 0">
          <li v-for="item in list" :key="item.demandId">
            <!-- 已完成状态 -->
            <img class="demandImg" 
              v-if="(item.dueDay <= 0 && item.orderNum == 0) || 
              item.status >= 4
              " 
              src="../../../assets/img/supply-and-demand-hall/havedRelease.png" alt="">
            <!-- 对接中状态 -->
            <img class="demandImg" 
              v-else
              src="../../../assets/img/supply-and-demand-hall/releaseing.png" alt="">
            <div class="title">
              <img
                src="../../../assets/img/supply-and-demand-hall/icon.png"
                alt=""
              />
              <h2 :title="item.demandName" style="width: 70% ;white-space: nowrap;  text-overflow:ellipsis; overflow:hidden;">{{ item.demandName }}</h2>
            </div>
            <div>
              <div class="col">
                采购量: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.quantity }}
              </div>
              <div class="col">已报价:{{ item.orderNum }}</div>
              <div class="col">发布时间:{{ item.publishTime }}</div>
              <div class="col">剩余时间:{{ item.dueDay }}天</div>
              <div class="col">
                采购价格:{{
                  item.budget === 0
                    ? "面议"
                    : item.budget === 1
                    ? "1-10万"
                    : item.budget === 2
                    ? "10-50万"
                    : item.budget === 3
                    ? "50-100万"
                    : "100万+"
                }}
              </div>
              <div class="col" :title="item.locationName">
                所在地区:{{ item.locationName }}
              </div>
            </div>
            <div class="btn" 
              @click="goDetail(item.demandId, item.demandCode)" 
              v-if="
              item.status >= 4 || 
              (item.dueDay <= 0 && item.orderNum > 0 && item.status < 4) ||
              (item.dueDay <= 0 && item.orderNum == 0) 
              ">查看详情</div>
            <div class="btn" @click="goDetail(item.demandId, item.demandCode)" v-else>立即报价</div>
          </li>
        </ul>
      </div>
      <br><br>
      <!-- 更多产品服务 -->
      <div class="list">
        <div class="listTitle">更多产品服务，源自平台的服务商</div>
        <div class="buttonBox">
          <el-button type="primary" @click="handleService">发布产品服务</el-button>
          <el-button type="primary" @click="handleServiceList">更多</el-button>
        </div>
        <h1 v-if="service.length === 0">暂无数据</h1>
        <ul class="clearfix" v-if="service.length > 0">
          <li v-for="item in service" :key="item.demandId" class="serviceLi">
            <div>
              <img :src="item.imageUrl" alt="" class="serviceImg">
            </div>
            <div style="line-height: 28px">
              <div
                :title="item.productName"
                style="
                  font-size: 16px; 
                  font-weight: 700;
                  width: 170px ;white-space: nowrap;  text-overflow:ellipsis; overflow:hidden;
                "
              >{{ item.productName }}</div>
              <div
                :title="item.desciption"
                style="
                width: 170px ;
                white-space: nowrap;  text-overflow:ellipsis; overflow:hidden;
                "
              >简介： {{ item.desciption }}</div>
              <div>公司： {{ item.corpName }}</div>
            <div class="btn" @click="goServiceDetail(item.productCode)">点击详情</div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 最新动态 -->
      <div class="bom">
        <div class="tit">
          <img
            src="../../../assets/img/supply-and-demand-hall/dongtai.png"
            alt=""
          />
          <h2>最新动态</h2>
        </div>
        <div class="dongtai">
          <div class="dongtai-list">
            <ul>
              <li v-for="(item, index) in dallList" :key="index">
                <img
                  class="dian"
                  src="../../../assets/img/supply-and-demand-hall/dian.png"
                  alt=""
                />
                <div>
                  <p>{{ item.conCorpName }}参与{{ item.demandName }}</p>
                  <span>{{ item.createTime }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="right-img">
          <img
            src="../../../assets/img/supply-and-demand-hall/jiejue4.png"
            alt=""
            @click="$router.push('/partnerPlan')"
            class="imgHandelCommon"
          />
          <img
            src="../../../assets/img/supply-and-demand-hall/jiejue1.png"
            alt=""
          />
          <img
            src="../../../assets/img/supply-and-demand-hall/jiejue2.png"
            alt=""
          />
          <img
            src="../../../assets/img/supply-and-demand-hall/jiejue3.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 认证提示 -->
    <Attestation
      :visible="attestationVisible"
      :flag="serviceFlag"
      @no="no"
      @yes="yes"
    ></Attestation>
  </div>
</template>

<script>
import {
  getSupplyList,
  getdemadDall,
  isServer
} from "@/api/tabs/supply-and-demand-hall";
import Attestation from "@/components/Attestation";
import { toControl } from "@/utils/control";
import { getServiceList } from '@/api/tabs/service'
import SupplyAndDemandHall from "@/views/tabs/Supply-and-demand-hall/Supply-and-demand-hall";
import { getSwiper } from "@/api/home";
import { mapState } from "vuex";
export default {
  components: {
    SupplyAndDemandHall,
    Attestation
  },
  data() {
    return {
      attestationVisible: false,
      serviceFlag: null,
      keyword: "",
      searchPage: {
        demandName: "",
        page: 1,
        size: 15,
        sortId: 1,
      },
      // 业务需求
      list: [],
      // 更多产品服务
      service:[],
      // 最新动态部分
      dallList: [],
      showDian: true,
      id: 0,
      height: "440px", //轮播图高度
      swiperList: [],
    };
  },
  computed: {
    ...mapState(["isLogin"]),
  },
  created(){
    this.getDallList();
    this.getSwiper();
    this.getList()
    this.initGetServiceList()
  },
  methods: {
    /**
     * 获取需求列表
     */
    getList() {
      getSupplyList().then((res) => {
        console.log(res)
        this.list = res.data;
      });
    },
    initGetServiceList(){
      getServiceList(
        {
          size: 3,
          page: 1,
          status: 3,
        }
      ).then(res=>{
        // console.log(res)
        if(!res.data.list){
          this.service = []
        }else {
          this.service = res.data.list
        }
      })
    },
    /**
     * 获取轮播图
     */
    getSwiper() {
      getSwiper({ carousel: "供需大厅" }).then((res) => {
        this.swiperList = res.data.slist;
      });
    },
    /**
     * 点击轮播图跳转
     */
    handleSwiper(item) {
      if (!item.point_address) return;

      if (item.jump_tupe == "0") {
        this.$router.push(item.point_address);
      } else {
        window.open(item.point_address);
      }
    },
    /**
     * 获取最新动态
     */
    getDallList() {
      getdemadDall().then((res) => {
        this.dallList = res.data;
      });
    },
    /**
     * 供需详情
     */
    goDetail(id, code) {
      if (this.isLogin) {
        let queryCode = `${id}&${code}`
        this.$router.push(`/supply-and-demand-hall/detail/${queryCode}`);
      } else {
        this.$router.push("/login")
      }
    },

    // 点击需求更多
    handleDemandList(){
      this.$router.push('/supply-and-demand-hall/demandList')
    },
    // 发布需求
    handleRelease(){
      if (this.isLogin) {
        this.$router.push('/release-requirements')
      } else {
        this.$router.push("/login")
      }
    },
    // 发布产品服务
    handleService(){
       if (this.isLogin) {
        isServer()
          .then(res=>{
            // console.log(res)
            if(res.data == false){
              this.attestationVisible = true;
              this.serviceFlag = 3
            }else{
              this.$router.push('/supply-and-demand-hall/serviceRequirements')
            }
          })
      } else {
        this.$router.push("/login")
      }
    },
    /**
     * 子组件确认取消按钮
     */
    no() {
      this.attestationVisible = false;
    },
    yes() {
      toControl("information/attestation");
      this.attestationVisible = false;
    },
    // 产品服务更多
    handleServiceList(){
      this.$router.push('/supply-and-demand-hall/serviceList')
    },
    // 服务点击详情
    goServiceDetail(id){
      if (this.isLogin) {
        this.$router.push(`/supply-and-demand-hall/service/detail/${id}`);
      } else {
        this.$router.push("/login")
      }
    }


  },
};
</script>

<style lang="less" scoped>
.fabu {
  position: fixed;
  right: 5px;
  top: 28%;
  z-index: 9999;
  img {
    width: 80px;
    cursor: pointer;
  }
}
.banner {
  width: 100%;
  .banner-img {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
  }
}
.news-nav {
  width: 100%;
  height: 85px;
  padding-top: 25px;
  background-color: #fff;
  box-shadow: 0px 6px 11px 0px rgba(0, 0, 0, 0.13);
  // margin-bottom: 62px;
  .nav-main {
    width: 1280px;
    // height: 110px;
    margin: 0 auto;
    position: relative;
    ul {
      // position: absolute;
      // bottom: 0;
      // left: 0;
      // height: 40px;
      li {
        width: 130px;
        height: 40px;
        display: inline-block;
        line-height: 40px;
        background: #ffffff;
        border-radius: 26px;
        border: 1px solid #e1e6f0;
        font-size: 18px;
        font-family: MicrosoftYaHei;
        text-align: center;
        color: #484848;
        margin-right: 30px;
        cursor: pointer;
      }
      li:hover {
        border: 1px solid #2a86f4;
        color: #0085fc;
      }
      .li-hover {
        border: 1px solid #2a86f4;
        color: #0085fc;
      }
      li:nth-child(8n + 0) {
        margin-right: 0;
      }
    }
    .search {
      position: absolute;
      right: 0;
      bottom: 19px;
      .el-input {
        width: 272px;
        height: 44px;
        display: inline-block;
      }
      .search-btn {
        width: 69px;
        height: 40px;
        display: inline-block;
        background-color: #2a86f4;
        text-align: center;
        line-height: 40px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
.list {
  width: 1280px;
  margin: 0 auto;
  margin-top: 30px;
  min-height: 300px;
  h1 {
    font-size: 34px;
    text-align: center;
    padding-top: 150px;
    color: #484848;
  }
  ul {
    li {
      position: relative;
      float: left;
      width: 381px;
      height: 240px;
      border: 1px solid #e1e6f0;
      margin-right: 20px;
      margin-top: 30px;
      padding: 20px 10px 10px 20px;
      .title {
        margin-bottom: 20px;
        img {
          width: 32px;
          height: 32px;
          vertical-align: middle;
        }
        h2 {
          margin-left: 20px;
          display: inline-block;
          vertical-align: middle;
        }
      }
      .col {
        display: inline-block;
        width: 170px;
        margin-bottom: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 15px;
      }
      .col:nth-child(2n + 0) {
        margin-right: 0;
      }
      .btn {
        display: inline-block;
        margin-right: 10px;
        margin-top: 25px;
        width: 120px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
        background-color: #fff;
        color: #2a86f4;
        border: 1px solid #2a86f4;
      }
      .btn:hover {
        background-color: #2a86f4;
        color: #fff;
        border: 1px solid #2a86f4;
      }
    }
    li:nth-child(3n + 0) {
      margin-right: 0;
    }
    li:hover {
      border: 1px solid #2a86f4;
      box-shadow: 0px 3px 6px 0px rgba(91, 187, 222, 0.5);
    }
  }
  .more {
    display: block;
    width: 128px;
    height: 32px;
    margin: 0 auto;
    margin-top: 30px;
    cursor: pointer;
  }
}
.bom {
  width: 1280px;
  margin: 0 auto;
  margin-bottom: 60px;
  margin-top: 60px;
  .tit {
    img {
      width: 16px;
      height: 14px;
      vertical-align: middle;
    }
    h2 {
      margin-left: 20px;
      display: inline-block;
      font-size: 16px;
      vertical-align: middle;
    }
  }
  .dongtai {
    display: inline-block;
    vertical-align: top;
    width: 625px;
    height: 390px;
    .dongtai-list {
      ul {
        li {
          cursor: pointer;
          margin-left: 30px;
          margin-top: 25px;
          height: 36px;
          img {
            vertical-align: middle;
          }
          .dian {
            width: 5px;
            height: 5px;
          }
          .img {
            width: 105px;
            height: 50px;
          }
          div {
            margin-left: 20px;
            display: inline-block;
            vertical-align: middle;
            width: 400px;
            p {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            span {
              display: inline-block;
              margin-top: 10px;
              font-size: 10px;
              color: #a1a1a1;
            }
          }
        }
        li:hover {
          p {
            color: #2a86f4;
          }
        }
      }
    }
  }
  .right-img {
    display: inline-block;
    width: 630px;
    height: 390px;
    img {
      width: 300px;
      height: 150px;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    img:nth-child(2n + 0) {
      margin-right: 0;
    }
  }
}
.listTitle {
  text-align: center;
  font-size: 24px;
}
.buttonBox {
  text-align: right;
}
.demandImg{
  position: absolute;
  right: 0;
  top: 0;
}
.serviceLi {
  display: flex;
  align-items: center;
}
.serviceLi .serviceImg {
  display: inline-block;
  width: 150px;
  height: 150px;
  // border: 1px solid skyblue;
  margin-right: 20px;
}
.imgHandelCommon {
  cursor: pointer;
}
</style>